export const articleFieldIds: Record<string, string> = {
  titulo: 'portal-article-field-titulo',
  slug: 'portal-article-field-slug',
  resumo: 'portal-article-field-resumo',
  tipo: 'portal-article-field-tipo',
  imagemCapaUrl: 'portal-article-field-imagem-capa-url',
  imagemCapaAlt: 'portal-article-field-imagem-capa-alt',
  imagemThumbUrl: 'portal-article-field-imagem-thumb-url',
  imagemThumbAlt: 'portal-article-field-imagem-thumb-alt',
  tituloOg: 'portal-article-field-titulo-og',
  descricaoOg: 'portal-article-field-descricao-og',
  imagemOgUrl: 'portal-article-field-imagem-og-url',
  imagemOgAlt: 'portal-article-field-imagem-og-alt',
}

export const portalEditorSettingsIds = {
  publish: 'portal-editor-settings-publish',
  article: 'portal-editor-settings-article',
  cover: 'portal-editor-cover-image-card',
  thumb: 'portal-editor-thumb-card',
  seo: 'portal-editor-seo-card',
  pillar: 'portal-editor-pillar-card',
}

export const portalEditorSectionIds = {
  faq: 'portal-editor-faq-card',
  cta: 'portal-editor-cta-card',
  courses: 'portal-editor-courses-card',
  relatedArticles: 'portal-editor-related-articles-card',
}

export function getPortalEditorFaqItemId(index: number) {
  return `portal-editor-faq-item-${index}`
}

export function getPortalEditorTopicId(topicId: string) {
  return `portal-editor-topic-${topicId}`
}

export function getPortalEditorTopicItemId(topicId: string, itemId: string | number) {
  return `portal-topic-${topicId}-item-${itemId}`
}
